import { __assign } from "tslib";
import { useContext } from 'react';
import { RumComponentContext } from './rum-component-context';
import { getGlobalObject } from '../utils/getGlobalObject';
/**
 * Utility to track actions in RUM with the component chain/breadcrumbs from <RumComponentContextProvider> automatically added
 *
 * add a "purpose" to the custom attributes to group the actions
 *
 *
 * @param purpose: explains the use case for the action, allows to split performance and user-tracking actions for example
 */
export var useRumAction = function (purpose) {
    if (purpose === void 0) { purpose = 'unknown'; }
    var componentContext = useContext(RumComponentContext);
    var RumGlobal = getGlobalObject().DD_RUM;
    if (!RumGlobal) {
        console.warn('@datadog/rum-react-integration: Datadog RUM SDK is not initialized.');
        return function () { };
    }
    return function (name, customAttributes) {
        var _a;
        RumGlobal.addAction(name, __assign(__assign(__assign({ purpose: purpose }, componentContext.customAttributes), customAttributes), { react: __assign({ breadcrumbs: componentContext.componentBreadCrumbs, component: componentContext.component }, (_a = customAttributes) === null || _a === void 0 ? void 0 : _a.react) }));
    };
};
//# sourceMappingURL=use-rum-action.js.map